import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'cream' | 'dark';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    cream: 'bg-[#FDFBF7]',
    dark: 'bg-stone-900 text-white'
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-396">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-397">{children}</div>
    </section>;
}